import { memo } from 'react';

import fallbackThumbnail from '../../../../../../assets/thumbnails/game_thumbnail_seven.png';
import { SocialCoin } from '../../../../../../components/SocialCoin/SocialCoin';
import { SweepCoin } from '../../../../../../components/SweepCoin/SweepCoin';
import type { WinnerTileVM } from '../../types';

import styles from './WinnerTile.module.scss';

interface WinnerTileProps {
  tile: WinnerTileVM;
}

export const WinnerTile = memo(({ tile }: WinnerTileProps) => {
  const isSweep = tile.mode === 'SC';

  return (
    <div className={styles.tile}>
      <img
        alt="provider logo"
        className={styles.thumb}
        draggable={false}
        loading="lazy"
        src={tile.gameImageUrl || fallbackThumbnail}
      />
      <div className={styles.info}>
        <span className={styles.nickname}>{tile.nickname}</span>
        <span className={styles.amountRow}>
          {isSweep ? <SweepCoin alt="" className={styles.coin} /> : <SocialCoin alt="" className={styles.coin} />}
          <span className={`${styles.amount} ${isSweep ? styles.amountSc : styles.amountCc}`}>
            {tile.amount.toLocaleString()}
          </span>
        </span>
      </div>
    </div>
  );
});

WinnerTile.displayName = 'WinnerTile';
